// extracted by mini-css-extract-plugin
module.exports = {"inner":"EmailVerifyInner_inner__UnDh1","title":"EmailVerifyInner_title__lXCiD","btn":"EmailVerifyInner_btn__PE4_k"};